import { Helmet } from "react-helmet-async";

const BASE = "GAVITO technic";
const SITE = "https://gavito.cz";

export const Seo = ({ title, description, path = "/", noindex = false }) => {
  const fullTitle = title ? `${title} | ${BASE}` : `${BASE} – Vzdělávací agentura`;
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, follow" />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
    </Helmet>
  );
};
